import prop from 'ramda/src/prop'
import compose from 'ramda/src/compose'
import equals from 'ramda/src/equals'
import __ from 'ramda/src/__'
import { MY_PROJECT_BANNER_HEADER_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default (state, props) => compose(equals(__, MY_PROJECT_BANNER_HEADER_MODULE_ID), prop('moduleId'))(props)
